import { Pipe, PipeTransform } from '@angular/core';
import { AttrCode } from 'src/app/core/enums/AttrCode';
import { StoreAttrResponse } from 'src/app/core/models/StoreAttrResponse';
import { StoreResponse } from 'src/app/core/models/StoreResponse';

@Pipe({
  name: 'storeImage'
})
export class StoreImagePipe implements PipeTransform {

  transform(input: StoreResponse | string | string[], passAttrCode?: string, isMultiple: boolean = false): string | string[] {
    let imageUrl: string[] = [];

    // CASE 1: Raw string (single image)
    if (typeof input === 'string') {
      imageUrl.push(this.normalizeImage(input, true));
      return isMultiple ? imageUrl : imageUrl[0];
    }

    // CASE 2: Raw array of image strings
    if (Array.isArray(input)) {
      imageUrl = input.map(img => this.normalizeImage(img, true));
      return imageUrl;
    }

    // CASE 3: StoreResponse with AttrCode
    const storeResponse = input as StoreResponse;

    if (!storeResponse || !storeResponse.storeAttrs || !passAttrCode) {
      imageUrl.push('assets/fying-pan.jpg');
      return isMultiple ? imageUrl : imageUrl[0];
    }

    let storeAttr: StoreAttrResponse[] = storeResponse.storeAttrs.filter(attr => {
      const stringWithoutNumber = attr.attrCode.split(/(\d+)/)[0];
      return stringWithoutNumber === passAttrCode;
    });

    if (storeAttr.length > 0) {
      for (const attr of storeAttr) {
        if (attr.attrData.trim() !== '') {
          imageUrl.push(this.normalizeImage(attr.attrData, false));
        }
      }
    } else {
      // Fallbacks
      if (passAttrCode === AttrCode.BANNERIMG) {
        const outletImg = storeResponse.storeAttrs.find(val => val.attrCode === AttrCode.OUTLETIMG);
        const currentImage = outletImg?.attrData ?? 'assets/fying-pan.jpg';
        imageUrl.push(this.normalizeImage(currentImage, false));
      } else if (passAttrCode === AttrCode.BIGBANNERIMG) {
        imageUrl = [];
      } else {
        imageUrl.push('assets/fying-pan.jpg');
      }
    }

    if (imageUrl && imageUrl.length == 0) {
      imageUrl.push('assets/fying-pan.jpg');
    }

    return isMultiple ? imageUrl : imageUrl[0];
  }

  //for storeResponse image use
  private normalizeImage(data: string, login: boolean): string {
    if (!data && !login) return 'assets/fying-pan.jpg';

    if (!data && login) return null;

    const trimmed = typeof data === 'string' ? data.trim() : '';
    if (!trimmed && login) return null;
    if (!trimmed && !login) return 'assets/fying-pan.jpg';

    const isFullDataURI = trimmed.startsWith('data:image/');
    // JPEG base64 starts with /9j/; it is not a root-relative image URL.
    // Check its alphabet too so paths such as /9j/banner.jpg stay unchanged.
    const isBase64Jpeg = trimmed.startsWith('/9j/') && /^[A-Za-z0-9+/\s]+={0,2}$/.test(trimmed);
    const isLikelyBase64 = isBase64Jpeg || (!trimmed.startsWith('http') && !trimmed.startsWith('assets/') && !trimmed.startsWith('/') && trimmed.length > 100);

    if (isFullDataURI) {
      return trimmed;
    } else if (isLikelyBase64) {
      let mime = 'image/jpeg';
      if (trimmed.startsWith('iVBORw0KGgo')) {
        mime = 'image/png';
      } else if (trimmed.startsWith('PHN2Zy') || trimmed.startsWith('PD94bW')) {
        mime = 'image/svg+xml';
      } else if (trimmed.startsWith('R0lGOD')) {
        mime = 'image/gif';
      } else if (trimmed.startsWith('UklGR')) {
        mime = 'image/webp';
      }
      return `data:${mime};base64,` + trimmed;
    } else {
      return trimmed;
    }
  }
}
